// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3X8Q2","title":"Info_title__1Ad3e","links":"Info_links__3IKOO","link":"Info_link__3Er9o","logo":"Info_logo__1UW41"};